<span class="label" [class.required]="field.is_required && !isProfessional">{{ field.label }}</span>
<span *ngIf="readOnly" class="read-only" [class.no-data]="fieldValue === NO_VALUE">{{ fieldValue }}</span>
<cm-custom-field-value
    *ngIf="!readOnly"
    class="control"
    [fieldType]="field.type_id"
    [value]="field.value"
    [options]="options"
    (valueChange)="onValueChange($event)"
>
</cm-custom-field-value>
